import { render, staticRenderFns } from "./createSuccess.vue?vue&type=template&id=a9dc1280&"
import script from "./createSuccess.vue?vue&type=script&lang=js&"
export * from "./createSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports